"use client";

import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

export default function useNotificationPermission() {
  const [permission, setPermission] = useState<NotificationPermission>("default");
  const [showPrompt, setShowPrompt] = useState(false);

  // Auto-request on mount (works in Chrome, ignored in Safari/Firefox)
  useEffect(() => {
    if (typeof window === "undefined" || !("Notification" in window)) return;

    setPermission(Notification.permission);

    if (Notification.permission !== "default") return;

    Notification.requestPermission()
      .then((status) => {
        setPermission(status);
        if (status === "granted") toast.success("Notifications enabled!");
        else if (status === "denied")
          toast.error("Notifications blocked – enable in browser settings.");
        else setShowPrompt(true); // Safari/Firefox ignore → show manual UI
      })
      .catch(() => setShowPrompt(true));
  }, []);

  const requestPermission = () => {
    if (permission !== "default") return;

    Notification.requestPermission()
      .then((status) => {
        setPermission(status);
        setShowPrompt(false);
        if (status === "granted")
          toast.success("Notifications enabled! You’ll get order & deal updates.");
        else if (status === "denied")
          toast.error("Notifications blocked – enable in browser settings.");
      })
      .catch(() => toast.error("Failed to request permission."));
  };

  return { permission, requestPermission, showPrompt };
}